module.exports = __webpack_public_path__ + "img/withdraw.476d1839.svg";